
import {Component, Prop, Vue} from "vue-property-decorator";
import NumberFilter from "@/components/utils/NumberFilter.vue";
import TooltipDialog from "@/components/utils/TooltipDialog.vue";

@Component({
    components: {NumberFilter, TooltipDialog}
})
export default class KeyNumbersFilterComptage extends Vue {

    @Prop() readonly product;
    @Prop() readonly loadingFilter: boolean;

    inputChange(field: string, valueType: string, value1: string, value2: string) {
        this.$emit('set-keynumbers', field, valueType, value1, value2);
    }
}
